import React, {useState, useEffect} from "react";
import "../../stylesheets/screen.css.scss";
import "../../stylesheets/_variables.scss";
import dataFile from "../../Data/dataFile.json";
import {useMyContext} from "../../context/MyContext";
import * as Constants from "../../constants/Constants";

function SubHeader({component}) {
  const allVersions = dataFile["allVersions"];
  const [isDropdownVisible, setIsDropdownVisible] = useState(false);
  const {setVersion, entity, version} = useMyContext();
  const entityVersionMap = dataFile["entityVersionMap"];

  const handleVersionClick = (version) => {
    setVersion(version);
    toggleDropdown();
  };
  useEffect(()=>{
    // if (component=== Constants.Values.SINGLE_API && entity) {
    //   const versions = entityVersionMap[entity];
    //   setVersion(versions[0]);
    // }

    // if (component === Constants.Values.VIEW_DOCUMENTATION ) {
    //   setVersion(allVersions[0]);
    // }
    const handleClickOutside = (event) => {
      if (!event.target.classList.contains("version-tag-option")&&!event.target.classList.contains("versionArrow")) {
        setIsDropdownVisible(false);
      }
    };

    window.addEventListener("click", handleClickOutside);

    return () => {
      window.removeEventListener("click", handleClickOutside);
    };
  }, [entity]);

  const toggleDropdown = () => {
    setIsDropdownVisible(!isDropdownVisible);
  };


  return (
    <div className="sub-header-bar">
      <div className="sub-header-bar-content">
        {entity? ( <div className="sub-header-bar-menu">
          <div className="version-tag" style={
            entity && entityVersionMap[entity].length <= 1 ?
              {pointerEvents: "none"} :
              {}
          }
          data-testid="version-tag"
          onClick={toggleDropdown}>
            {version} {entity&&entityVersionMap[entity].length>1&&<span className="versionArrow">﹀</span>}{" "}
          </div>{" "}
          <div id="version-list" data-testid="version-list" className={isDropdownVisible?"version-tag-option version-active show":"version-tag-option version-active"} >
            {entity&&entityVersionMap[entity].map((version) => (
              <a
                key={version}
                data-testid ={version}
                onClick={() => handleVersionClick(version)}
              >
                {version}
              </a>
            ))}
          </div>
        </div>):
          component!=="GetStarted"&&(
            <div className="sub-header-bar-menu">
              <div className="version-tag" data-testid="version-tag" onClick={toggleDropdown}
                style={
                  entity && entityVersionMap[entity].length <= 1 ?
                    {pointerEvents: "none"} :
                    {}
                }>
                {version} <span className="versionArrow">﹀</span>{" "}
              </div>{" "}
              <div id="version-list" data-testid="version-list" className={isDropdownVisible?"version-tag-option version-active show":"version-tag-option version-active"} >
                {allVersions&&allVersions.map((version) => (
                  <a
                    key={version}
                    data-testid ={version}
                    onClick={() => handleVersionClick(version)}
                  >
                    {version}
                  </a>
                ))}
              </div>
            </div>
          )}

      </div>
    </div>
  );
}

export default SubHeader;
